{/* Previous ContactPage.tsx content with updated phone number */}
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Footer } from '../components/Footer';
import { ArrowLeft, Phone, Mail, Clock, Building2, ArrowRight } from 'lucide-react';

const contactMethods = [
  {
    icon: Phone,
    title: 'Phone',
    description: 'Available Monday - Friday',
    value: '(914) 960-6433',
    action: 'Call now',
    href: 'tel:9149606433'
  },
  {
    icon: Mail,
    title: 'Email',
    description: 'Send us your inquiries',
    value: 'info@renovationwestchester.com',
    action: 'Send email',
    href: 'mailto:info@renovationwestchester.com'
  },
  {
    icon: Clock,
    title: 'Business Hours',
    description: 'Monday - Friday',
    value: '7:00 AM - 7:00 PM',
    action: 'Schedule call',
    href: 'tel:9149606433'
  }
];

export function ContactPage() {
  return (
    <div className="min-h-screen bg-zinc-900">
      <Helmet>
        <title>Contact Us | Westchester Renovation Company</title>
        <meta name="description" content="Contact Westchester Renovation Company for premium renovation services in Westchester County, NY and Fairfield County, CT." />
        <meta name="keywords" content="contact renovation contractor, Westchester renovation contact, Fairfield County renovation contact" />
        <link rel="canonical" href="https://renovationwestchester.com/contact" />
      </Helmet>


      <main className="pt-24">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <Link to="/" className="inline-flex items-center gap-2 text-yellow-400 mb-12 hover:gap-4 transition-all duration-300">
            <ArrowLeft className="h-4 w-4" />
            <span className="text-sm tracking-wider">Back to Home</span>
          </Link>

          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-light text-zinc-100 mb-6">Get in Touch</h1>
            <p className="text-zinc-400 max-w-2xl mx-auto leading-relaxed">
              Ready to transform your space? Our team of experts is here to help bring your vision to life 
              with unparalleled craftsmanship and attention to detail.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-24">
            {contactMethods.map((method, index) => (
              <div key={index} className="bg-zinc-800/30 p-8 text-center group">
                <method.icon className="h-8 w-8 text-yellow-400 mx-auto mb-4" />
                <h2 className="text-xl text-zinc-100 mb-2">{method.title}</h2>
                <p className="text-zinc-400 text-sm mb-4">{method.description}</p>
                <p className="text-zinc-200 mb-6">{method.value}</p>
                <a 
                  href={method.href}
                  className="inline-flex items-center gap-2 text-yellow-400 text-sm tracking-wider group-hover:gap-4 transition-all duration-300"
                >
                  {method.action} <ArrowRight className="h-4 w-4" />
                </a>
              </div>
            ))}
          </div>

          <div className="bg-zinc-800/30 p-12 text-center">
            <Building2 className="h-12 w-12 text-yellow-400 mx-auto mb-6" />
            <h2 className="text-3xl font-light text-zinc-100 mb-4">Ready to Start Your Project?</h2>
            <p className="text-zinc-400 mb-8 max-w-2xl mx-auto">
              Schedule a consultation with our expert team to discuss your vision and receive 
              a detailed project assessment.
            </p>
            <Link 
              to="/consultation"
              className="inline-flex items-center gap-4 px-8 py-4 bg-yellow-400 text-zinc-900 group"
            >
              <span className="text-sm tracking-wider">Schedule a Consultation</span>
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}